import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useRouter } from "next/router";
import { useCallback } from "react";
export function useBuildId() {
  var _useRouter = useRouter(),
      basePath = _useRouter.basePath;

  var shouldReload = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _JSON$parse, buildId, res;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!false) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", false);

          case 2:
            _context.prev = 2;
            buildId = (_JSON$parse = JSON.parse(document.querySelector("#__NEXT_DATA__").textContent)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.buildId;
            _context.next = 6;
            return fetch("".concat(basePath, "/api/buildid?id=").concat(buildId)).then(function (data) {
              return data.json();
            });

          case 6:
            res = _context.sent;
            return _context.abrupt("return", !res.result);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            console.log(_context.t0);
            return _context.abrupt("return", false);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  })), []);
  return {
    shouldReload: shouldReload
  };
}